import { RequestConfig } from '@/interface'

const PRIFIX = 'fpgl/fpc/'
const FPCY_PRIFIX = 'ypgl/fpcy/'
const FPZT_PRIFIX = `${PRIFIX}fpzt/`
const invoicePoolConfig: RequestConfig = {
  // 代扣代缴完税凭证明细列表
  dkdjwspzPgae: {
    url: `${PRIFIX}dkdjwspzPgae`,
    method: 'post'
  },
  // 完税证明详情
  getWspzInfo: {
    url: `${PRIFIX}getWspzInfo`,
    method: 'get'
  },
  // 发票明细
  fpmx: {
    url: `${PRIFIX}fpmx`,
    method: 'get'
  },
  // 发票详情
  fpDetail: {
    url: `${PRIFIX}fpmx`,
    method: 'post'
  },
  // 发票明细列表
  fpmxPgae: {
    url: `${PRIFIX}fpmxPgae`,
    method: 'post'
  },
  // 发票统计
  fptj: {
    url: `${PRIFIX}fptj`,
    method: 'post'
  },
  // 海关缴款书明细列表
  hgjksPage: {
    url: `${PRIFIX}hgjksPage`,
    method: 'post'
  },
  // 海关缴款书详情
  getHgjksInfo: {
    url: `${PRIFIX}getHgjksInfo`,
    method: 'get'
  },
  // 发票池销项发票和进项发票列表
  invoiceQyxx: {
    url: `${PRIFIX}qyxx`,
    method: 'post'
  },
  // 销项发票池销购方统计
  xgfTj: {
    url: `${PRIFIX}xgfTj`,
    method: 'post'
  },
  // 销项发票统计
  xxfptj: {
    url: `${PRIFIX}xxfptj`,
    method: 'post'
  },
  // 进项发票统计
  jxfptj: {
    url: `${PRIFIX}jxfptj`,
    method: 'post'
  },
  // 开票受票对比
  kpspxx: {
    url: `${PRIFIX}kpspxx`,
    method: 'post'
  },
  // 手动签收
  fpcyFile: {
    url: `${FPCY_PRIFIX}file`,
    method: 'post'
  },
  // 统计分析
  tjfxFptj: {
    url: `${PRIFIX}fptj`,
    method: 'post'
  },
  // 发票池导出
  fpcExport: {
    url: `${PRIFIX}expert`,
    method: 'post'
  },
  // 抵扣发票统计
  dkfptj: {
    url: `${PRIFIX}dkfptj`,
    method: 'post'
  },
  // 统计分析-导出
  fptjdc: {
    url: `${PRIFIX}fptjdc`,
    method: 'post'
  },
  // 统计分析-进项票认证统计导出
  dkfptjdc: {
    url: `${PRIFIX}dkfptjdc`,
    method: 'post'
  },
  // 发票查验文件上传
  fpcyFileUpload: {
    url: `${FPCY_PRIFIX}file`,
    method: 'post'
  },
  // 导出（税局版）
  exportTax: {
    url: `${PRIFIX}expert/standard`,
    method: 'post'
  },
  // 发票状态信息同步
  fpztSync: {
    url: `${FPZT_PRIFIX}sync`,
    method: 'post'
  },
  // 发票状态信息同步记录
  fpztSyncList: {
    url: `${FPZT_PRIFIX}log/list`,
    method: 'post'
  },
  // 发票状态信息状态
  fpztSyncStatus: {
    url: `${FPZT_PRIFIX}sync/status`,
    method: 'get'
  }
}
export default invoicePoolConfig
